<template>
  <div>
    <h2 class="text-1xl font-bold text-gray-700">Desembolsos o egresos</h2>
    <MainDisbursements />
  </div>
</template>

<script>
import MainDisbursements from "@/components/Disbursements/MainDisbursements.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";
export default {
  name: "DisbursementsData",
  components: {
    MainDisbursements,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
